export const getLocale = () => {
  return getLocaleFromBrowser();
};

function getLocaleFromBrowser() {
  if(navigator.language.slice(0, 2) == 'ja' || navigator.language.slice(0, 2) == 'en') {
    return navigator.language.slice(0, 2); // ja-JP en-US 等に対応
  }
  return 'ja'; // 対応外のlocaleの場合は日本語を設定
}
